import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { goldDict } from "@/lib/shop/products/gold";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/24kt-gold")({
  head: () => ({
    ...buildProductHead(goldDict),
    links: alternateLinkList("/shop/24kt-gold", "en"),
  }),
  component: () => <ProductPage dict={goldDict} />,
});